import { defineMessages } from 'react-intl';

import { OrderDocumentType } from '@savgroup-front-common/types';

export const orderDocumentTypeMessages = defineMessages({
  [OrderDocumentType.DELIVERY_NOTE]: {
    id: 'orderDocumentType.deliveryNote',
    defaultMessage: 'Delivery Note',
  },
  [OrderDocumentType.ORDER]: {
    id: 'orderDocumentType.order',
    defaultMessage: 'Order',
  },
  [OrderDocumentType.SALES_RECEIPT]: {
    id: 'orderDocumentType.salesReceipt',
    defaultMessage: 'Sales Receipt',
  },
});
